import { colors, ColorKeys } from "./colors"
import * as CSS from "csstype"

export type BorderColorKeys = Extract<
	ColorKeys,
	"navy" | "blue33" | "blue66" | "coral66"
>

export const borderColors: Record<BorderColorKeys, CSS.Property.Color> = {
	navy: colors["navy"],
	blue33: colors["blue33"],
	blue66: colors["blue66"],
	coral66: colors["coral66"],
}

export const borderKeys = Object.keys(borderColors) as BorderColorKeys[]
